<template>
  <div class="vesion-container">
    <el-button type="three" @click="add">生成当前版本</el-button>
    <el-table
      :data="versionList"
      style="width: 100%"
      :header-cell-style="{ background: '#F0F3F7', color: '#39475B' }"
      :cell-style="{
        background: '#FCFDFF',
        'font-size': '14px',
        color: '#8998AC',
      }"
    >
      <el-table-column prop="id" label="版本号"> </el-table-column>

      <el-table-column prop="scription" label="版本说明"> </el-table-column>
      <el-table-column prop="publish_time" label="发布时间"> </el-table-column>
      <el-table-column prop="status" label="生效状态">
        <template slot-scope="scope">{{ getStatusText(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="operation" label="操作人员"> </el-table-column>

      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <my-operation
            :scope="scope"
            @add="add"
            @deleteItem="deleteItem"
          ></my-operation>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
      prev-text="上一页"
      next-text="下一页"
      v-if="total > 10"
    />
    <el-dialog
      :close-on-click-modal="false"
      :title="`${opType == 'add' ? '新增' : '编辑'}当前版本`"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
    >
      <el-form label-width="100px">
        <el-form-item label="版本号：">
          <el-input v-model="versionForm.id"></el-input>
        </el-form-item>
        <el-form-item label="版本说明：">
          <el-input v-model="versionForm.scription" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="操作人员：">
          <el-input v-model="versionForm.operation"></el-input>
        </el-form-item>
        <el-form-item label="版本状态：">
          <el-radio-group v-model="versionForm.status">
            <el-radio :label="1">生效</el-radio>
            <el-radio :label="2">不生效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" round @click="handleClose">取消</el-button>
        <el-button size="medium" round type="primary" @click="confirm"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    components: {
      'my-operation': () => import('@/components/operation/index.vue'),
    },
    data() {
      return {
        searchInfo: {
          tel: '',
          start_time: '',
          end_time: '',
        },
        time: '',
        currentPage: 1,
        total: 0,
        versionList: [
          {
            id: 1,
            scription: 'hahaoif',
            operation: '电话',
            status: 1,
            publish_time: 'resrse',
          },
        ],
        versionForm: {
          id: '',
          scription: '',
          status: 1,
          operation: '',
        },
        dialogVisible: false,
        opType: 'add',
      }
    },
    computed: {
      getStatusText() {
        return ({ status }) => (status == 1 ? '使用中' : '已失效')
      },
    },
    methods: {
      handleChange(e) {
        if (e == null) {
          this.searchInfo = {
            start_time: '',
            end_time: '',
          }
        } else {
          this.searchInfo.start_time = parseInt(e[0]) / 1000
          this.searchInfo.end_time = parseInt(e[1]) / 1000
        }

        // this.getLists({ type: 'search' })
      },
      handleCurrentChange() {},
      add(row) {
        if (row.id) {
          this.versionForm = row
          this.opType = 'edit'
        }
        this.dialogVisible = true
      },
      deleteItem(row) {},
      handleClose() {
        this.opType = 'add'
        this.versionForm = {
          id: '',
          scription: '',
          status: 1,
          operation: '',
        }
        this.dialogVisible = false
      },
      confirm() {},
    },
  }
</script>

<style lang="scss">
  .vesion-container {
    .el-table {
      margin-top: 20px;
    }
  }
</style>
